import { FormikProvider, useFormik } from "formik";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { INFERENCE_STATUSES, InferenceStatus, UserPolices } from "constant";
import features from "features";
import usePolicy from "hooks/usePolicy";
import { RootStateInterface } from "reducer";
import { LayersManagerStateInterface } from "scenes/LayersManager/interfaces";

import InferenceStatusComponent from "components/InferenceStatusComponent/InferenceStatusComponent";
import FormField from "components/inputs/FormField/FormField";
import UploadFiles from "components/inputs/UploadFiles/UploadFiles";

import styles from "./provider-folder.module.scss";

const ProviderFolder = ({ id, alias, folderId, setFolderId }) => {
  const dispatch = useDispatch();
  const { hasPolicy } = usePolicy();
  const provider: any = useSelector<
    RootStateInterface,
    LayersManagerStateInterface
  >((state) =>
    state.layersManager.providers.find((item) => item.id === folderId)
  );

  const onSubmit = useCallback(
    async (e) => {
      const providerId = await formik.submitForm();
      const files = e.target.files;
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("files[]", files[i]);
      }

      dispatch(
        features.layersManager.actions.uploadProviderFilesRequest({
          params: { id, alias, providerId },
          fields: formData
        })
      );
    },
    [alias, dispatch, folderId, id]
  );

  // const onDelete = useCallback(
  //   (id) => () => {
  //     console.log(id);
  //   },
  //   []
  // );

  const formik = useFormik({
    validateOnChange: true,
    initialValues: {
      folder: provider?.data?.name || ""
    },
    validateOnMount: true,
    enableReinitialize: true,

    onSubmit: (val) => {
      return new Promise((resolve, reject) => {
        if (!provider)
          dispatch(
            features.layersManager.actions.createProviderRequest({
              params: { id, alias },
              fields: { name: val.folder },
              onSuccess: (res) => {
                const providerId = res.providers.pop().id;
                resolve(providerId);
                setFolderId(providerId);
              },
              onError: () => {
                reject(false);
              }
            })
          );
        else resolve(folderId);
      });
    }
  });

  return (
    <div className={styles["wrapper"]}>
      <FormikProvider value={formik}>
        <FormField
          name={"folder"}
          className={styles["field"]}
          placeholder="Type folder name"
          disabled={provider}
        />
      </FormikProvider>
      {formik.values.folder.length > 0 && (
        <>
          {hasPolicy(UserPolices.PROJECT_PROVIDER_CREATE) && !provider?.photos && (
            <div className={styles["modal__upload"]}>
              <label className={styles["label"]}>
                Please select img to upload
              </label>
              <UploadFiles
                title="Upload img"
                handleFileChange={onSubmit}
                isMultiple
              />
            </div>
          )}
          <div className={styles["modal__providers-table"]}>
            <div className={styles["providers-table__head"]}>
              <div>№</div>
              <div>Name</div>
              {/* <div>Action</div> */}
              <div>Status upload</div>
            </div>

            <div className={styles["providers-table__body"]}>
              {provider?.photos?.map((item, index) => (
                <div
                  key={`provider-photo-${index}`}
                  className={styles["providers-table__row"]}
                >
                  <div className={styles["name"]}>{index + 1}</div>
                  <div className={styles["name"]}>{item.name}</div>
                  {/* <IconButton
                    onClick={onDelete(item.id)}
                    icon={TrashIcon}
                    alt="trash-icon"
                    disabled={true}
                    // disabled={item.isDeleteProviderLoading}
                    // isLoading={item.isDeleteProviderLoading}
                  /> */}
                  <InferenceStatusComponent
                    status={
                      item.status === "available"
                        ? INFERENCE_STATUSES[InferenceStatus.DONE]
                        : INFERENCE_STATUSES[provider?.inference?.status]
                    }
                    completionPercentage={
                      provider?.inference?.status === InferenceStatus.UPLOADING
                        ? provider?.inference?.fileUploadData.progress
                        : undefined
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ProviderFolder;
